import { AdTagType } from 'bitmovin-player';
import { NpoPlayerUIVariants } from '../../types/interfaces';
import { NpoPlayerEvent } from '../../types/events';
export async function handlePreRolls(playerContext) {
    return new Promise((resolve) => {
        if (playerContext.npoplayer.streamObject.metadata.hasPreroll == 'false' ||
            playerContext.npoplayer.streamObject.assets.preroll == undefined) {
            resolve();
            return;
        }
        const prerollUrl = playerContext.npoplayer.streamObject.assets.preroll;
        let adIndex = 0;
        let totalAds = 0;
        let currentClickListener;
        let adUiSet = false;
        async function handleReady() {
            playerContext.player.off(NpoPlayerEvent.Ready, handleReady);
            const advertConfig = {
                tag: {
                    url: String(prerollUrl),
                    type: AdTagType.VAST
                },
                id: 'Ad',
                position: 'pre'
            };
            await playerContext.player.scheduleAds(advertConfig);
        }
        playerContext.player.on(NpoPlayerEvent.Ready, handleReady);
        async function handlePlay() {
            playerContext.player.off(NpoPlayerEvent.Play, handlePlay);
            attemptSetAdUi();
        }
        playerContext.player.on(NpoPlayerEvent.Play, handlePlay);
        function setAdUi() {
            const activeAdBreak = playerContext.player.getActiveAdBreak();
            if (!activeAdBreak || !activeAdBreak.ads)
                return false;
            playerContext.npoplayer.uiManager?.release();
            playerContext.npoplayer.uiManager = undefined;
            if (playerContext.npoplayer.playerContext) {
                playerContext.player.createUIManager(playerContext, NpoPlayerUIVariants.AD);
            }
            adUiSet = true;
            const adButton = playerContext.npoplayer.uiComponents.adbutton;
            const currentAd = activeAdBreak.ads[0];
            adIndex = 1;
            totalAds = activeAdBreak.ads.length;
            if (adButton) {
                adButton.show();
                adClickHandler(currentAd, adButton);
            }
            playerContext.npoplayer.uiComponents.adlabel?.setText(`Advertentie 1 van ${activeAdBreak.ads.length}`);
            return true;
        }
        function attemptSetAdUi(attemptsLeft = 10) {
            if (attemptsLeft <= 0)
                return;
            if (!adUiSet) {
                setAdUi();
                setTimeout(() => {
                    attemptSetAdUi(attemptsLeft - 1);
                }, 200);
            }
        }
        function handleAdStarted() {
            playerContext.player.off(NpoPlayerEvent.AdStarted, handleAdStarted);
            const activeAdBreak = playerContext.player.getActiveAdBreak();
            if (!activeAdBreak || !activeAdBreak.ads) {
                console.error('No active ad break data found');
                return;
            }
            if (!adUiSet)
                attemptSetAdUi();
            playerContext.npoplayer.adBreakActive = true;
        }
        playerContext.player.on(NpoPlayerEvent.AdStarted, handleAdStarted);
        function adClickHandler(ad, button) {
            const clickThroughCallback = ad.clickThroughUrlOpened;
            if (currentClickListener)
                button.onClick.unsubscribe(currentClickListener);
            currentClickListener = () => {
                try {
                    window.open(ad.clickThroughUrl, '_blank');
                    playerContext.player.pause();
                    if (clickThroughCallback)
                        clickThroughCallback();
                }
                catch (error) {
                    console.log(error);
                }
            };
            button.onClick.subscribe(currentClickListener);
        }
        function handleAdFinished() {
            playerContext.player.off(NpoPlayerEvent.AdFinished, handleAdFinished);
            const activeAdBreak = playerContext.player.getActiveAdBreak();
            if (!activeAdBreak || !activeAdBreak.ads) {
                console.error('No active ad break data found');
                return;
            }
            if (adIndex >= totalAds) {
                handleAdBreakFinished();
                return;
            }
            const adButton = playerContext.npoplayer.uiComponents.adbutton;
            const nextAd = activeAdBreak.ads[adIndex];
            adIndex += 1;
            if (adButton) {
                adButton.show();
                adClickHandler(nextAd, adButton);
            }
            playerContext.npoplayer.uiComponents.adlabel?.setText(`Advertentie ${adIndex} van ${activeAdBreak.ads.length}`);
        }
        playerContext.player.on(NpoPlayerEvent.AdFinished, handleAdFinished);
        function handleAdBreakFinished() {
            playerContext.player.off(NpoPlayerEvent.AdBreakFinished, handleAdBreakFinished);
            playerContext.player.off(NpoPlayerEvent.AdError, handleAdBreakFinished);
            playerContext.npoplayer.adBreakActive = false;
            playerContext.npoplayer.uiComponents.adbutton?.hide();
            playerContext.npoplayer.uiComponents.adlabel?.hide();
            playerContext.npoplayer.uiManager?.release();
            playerContext.npoplayer.uiManager = undefined;
            if (playerContext.npoplayer.playerContext) {
                playerContext.player.createUIManager(playerContext, NpoPlayerUIVariants.DEFAULT);
            }
            adUiSet = false;
            resolve();
        }
        playerContext.player.on(NpoPlayerEvent.AdBreakFinished, handleAdBreakFinished);
        playerContext.player.on(NpoPlayerEvent.AdError, handleAdBreakFinished);
    });
}
